import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSofa: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"sofa, couch, chill"} maskId="square-filled-radius-0-stroke-1-IconSofa"><path d="M3 11V4H21V11H18V13H6V11H3Z" fill="currentColor"/><path d="M1 12V18H4V20H5V18H19V20H20V18H23V12H19V14H5V12H1Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSofa;
